import {
  TRIGGER_LOGOUT,
  SUCCESS_MESSAGE,
  ERROR_MESSAGE,
  IS_LOADING,
  UPDATE_MARKETING_USER,
  UPDATE_MARKETING_PARTNER,
  UPDATE_MARKETING_PARTNER_FROM_PROMO,
  GET_DEMO,
  GET_DEMO_FAIL,
  GET_DEMO_SUCCESS,
  UPDATE_DEMO,
  UPDATE_DEMO_FAIL,
  UPDATE_DEMO_SUCCESS
} from "app/DealMachineCore/types";

import { appRedirect, AppConfig } from "app/NativeActions";

import PrivateAPI from "app/DealMachineCore/apis/DealMachinePrivateAPI";
import api from "app/DealMachineCore/apis/DealMachineAPIV2";

const dm_private_api = PrivateAPI.create();
const dm_api = api.create();

const saveMarketingData = async ({ prop, value }) => {
  try {
    window.localStorage.setItem(prop, value);
  } catch (error) {}
};

export const updateMarketingUser = ({ prop, value }) => {
  saveMarketingData({ prop, value });

  return {
    type: UPDATE_MARKETING_USER,
    payload: { prop, value }
  };
};

export const updateMarketingPartner = ({ prop, value }) => {
  saveMarketingData({ prop, value });

  return {
    type: UPDATE_MARKETING_PARTNER,
    payload: { prop, value }
  };
};

export const getPartnerFromPromo = promo => {
  return dispatch => {
    dm_private_api.getPartnerFromPromo({ promo }).then(response => {
      if (response.problem != null) {
      } else if (response.data.error != false) {
      } else {
        dispatch({
          type: UPDATE_MARKETING_PARTNER_FROM_PROMO,
          payload: response.data.results
        });
      }
    });
  };
};

export const getDemos = ({ type, webinar_id }) => {
  return dispatch => {
    dispatch({
      type: GET_DEMO
    });
    dm_api.getDemos({ type, webinar_id }).then(response => {
      if (response.problem != null) {
        dispatch({
          type: GET_DEMO_FAIL,
          payload: response.problem
        });
      } else if (response.data.error != false) {
        dispatch({
          type: GET_DEMO_FAIL,
          payload: response.data.error
        });
      } else {
        dispatch({
          type: GET_DEMO_SUCCESS,
          payload: response.data.results
        });
      }
    });
  };
};

export const updateDemo = ({
  type,
  webinar_id,
  occurrence_id,
  user_id,
  firstname,
  lastname,
  email,
  phone,
  onSuccess = null
}) => {
  return dispatch => {
    dispatch({
      type: UPDATE_DEMO
    });

    dispatch({ type: IS_LOADING, payload: true });

    dm_api
      .updateDemo({
        type,
        webinar_id,
        occurrence_id,
        user_id,
        firstname,
        lastname,
        email,
        phone
      })
      .then(response => {
        if (response.problem != null) {
          dispatch({
            type: UPDATE_DEMO_FAIL,
            payload: response.problem
          });
          dispatch({
            type: ERROR_MESSAGE,
            payload: { message: response.problem, title: "Error" }
          });
        } else if (response.data.error != false) {
          dispatch({
            type: UPDATE_DEMO_FAIL,
            payload: response.data.error
          });
          dispatch({
            type: ERROR_MESSAGE,
            payload: { message: response.data.error, title: "Error" }
          });
        } else {
          dispatch({
            type: UPDATE_DEMO_SUCCESS,
            payload: response.data.results
          });

          dispatch({
            type: SUCCESS_MESSAGE,
            payload: {
              message:
                "You have successfully registered. Check your email for more details.",
              title: "Success!"
            }
          });

          if (onSuccess) {
            onSuccess();
          }
        }
      });
  };
};
